import { useState } from 'react';

export default function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function setFormFieldsAndVals(event) {
      setValues({
        ...fields,
        [event.target.id]: event.target.value,
      });
    },
  ];
}
